import { Component } from '@angular/core';
import { LoadingController } from 'ionic-angular';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

import { Storage } from '@ionic/storage';

// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

@Component({
  selector: 'page-historico',
  templateUrl: 'historico.html',
})

export class HistoricoPage {
	pontos = [];
	sempontos = false;

	constructor(private _apiService: ApiProvider, private storage: Storage, private loadingCtrl: LoadingController, private _auth: AuthProvider, private _msg: TranslateMsgProvider)
	{
		let loading = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+'...'/*,
            dismissOnPageChange: true*/
        });
        loading.present();

        this.storage.get('id_cliente').then((val) =>
        {
        	this.storage.get('id_empresa_escolhida').then((val2) =>
        	{
				this._apiService.getHistorico({id_cliente: val, id_empresa_escolhida:val2}).subscribe(arg =>
				{
        			loading.dismiss();
					if(!arg)
					{
						this.sempontos = true;
					}
					else
					{
						this.sempontos = false;
						this.pontos = arg;
					}
				});
        	});
        });
	}

	// Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter()
    {
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
        this._auth.checkempresa();
    }

}



// WEBPACK FOOTER //
// ./src/pages/historico/historico.ts